import { Navigate, Route } from 'react-router-dom';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { useFeatureFlag } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag, FeatureFlagStatus } from '@pflegenavi/shared/api';
import { lazy, useMemo, type JSX } from 'react';
import { DefaultSuspense } from '@pflegenavi/web-components';

const AccountingExpensesPage = lazy(() => import('./AccountingExpensesPage'));

export const useExpenseManagementRoutes = (): JSX.Element | null => {
  const expenseManagementEnabled =
    useFeatureFlag(FeatureFlag.ExpenseManagement) === FeatureFlagStatus.Enabled;

  return useMemo(() => {
    if (!expenseManagementEnabled) {
      return null;
    }

    return (
      <Route path={nhAppMainPages.EXPENSE_MANAGEMENT}>
        <Route
          index={true}
          element={
            <Navigate to={nhAppMainPages.EXPENSE_MANAGEMENT_OPEN} replace />
          }
        />
        <Route
          path={nhAppMainPages.EXPENSE_MANAGEMENT_OPEN}
          element={
            <DefaultSuspense>
              <AccountingExpensesPage tab="open" />
            </DefaultSuspense>
          }
        />
        <Route
          path={nhAppMainPages.EXPENSE_MANAGEMENT_SCHEDULED}
          element={
            <DefaultSuspense>
              <AccountingExpensesPage tab="scheduled" />
            </DefaultSuspense>
          }
        />
        <Route
          path={nhAppMainPages.EXPENSE_MANAGEMENT_EXPORTED}
          element={
            <DefaultSuspense>
              <AccountingExpensesPage tab="exported" />
            </DefaultSuspense>
          }
        />
      </Route>
    );
  }, [expenseManagementEnabled]);
};
